import { z } from "zod";
import { paginationSchema } from "../schemas/common.js";
import {
  betaAccessRequestStatusSchema,
  betaAccessTypeSchema,
  betaAllowlistStatusSchema,
  normalizeBetaEmail,
} from "./index.js";

export const betaAccessAdminListQuerySchema = paginationSchema.extend({
  status: betaAccessRequestStatusSchema.optional(),
  q: z.string().trim().max(200).optional(),
});

export const betaAllowlistAdminListQuerySchema = paginationSchema.extend({
  status: betaAllowlistStatusSchema.optional(),
  accessType: betaAccessTypeSchema.optional(),
  q: z.string().trim().max(200).optional(),
});

export const approveBetaAccessRequestSchema = z.object({
  accessType: betaAccessTypeSchema.default("BETA"),
  companyName: z.string().trim().max(120).optional(),
});

export const rejectBetaAccessRequestSchema = z.object({
  reason: z.string().trim().max(500).optional(),
});

export const addBetaAllowlistEntrySchema = z.object({
  email: z.string().trim().email().max(320),
  accessType: betaAccessTypeSchema.default("BETA"),
  companyName: z.string().trim().max(120).optional(),
  status: betaAllowlistStatusSchema.default("INVITED"),
});

export const updateBetaAllowlistEntrySchema = z.object({
  accessType: betaAccessTypeSchema.optional(),
  status: betaAllowlistStatusSchema.optional(),
  companyName: z.string().trim().max(120).optional().nullable(),
});

export const betaAccessRequestIdParamSchema = z.object({
  requestId: z.string().uuid(),
});

export const betaAllowlistEmailParamSchema = z.object({
  email: z
    .string()
    .min(1)
    .max(500)
    .transform((value) => normalizeBetaEmail(decodeURIComponent(value)))
    .pipe(z.string().email().max(320)),
});

export type BetaAccessAdminListQuery = z.infer<typeof betaAccessAdminListQuerySchema>;
export type BetaAllowlistAdminListQuery = z.infer<typeof betaAllowlistAdminListQuerySchema>;
export type ApproveBetaAccessRequestInput = z.infer<typeof approveBetaAccessRequestSchema>;
export type RejectBetaAccessRequestInput = z.infer<typeof rejectBetaAccessRequestSchema>;
export type AddBetaAllowlistEntryInput = z.infer<typeof addBetaAllowlistEntrySchema>;
export type UpdateBetaAllowlistEntryInput = z.infer<typeof updateBetaAllowlistEntrySchema>;
